import {
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Upload,
  DatePicker,
  Switch
} from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import {
  formatCurrency,
  formatCurrencyLabel,
  LINK_API_IMAGE
} from '../../config-func'
import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined
} from '@ant-design/icons'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import { TMCE_KEY, UTILITY_OPTIONS } from '../../configData'
import { upLoadImage } from '../../services/postservice'
import openNotification from '../common/Notification/openNotification '
import dayjs from 'dayjs'
import { debounce } from 'lodash'

import { Editor } from '@tinymce/tinymce-react'
import { useRef } from 'react'
import { getAllSelections } from '../../services/selection-list-service'
const keytiny = 'qjdmfbq800ojy8yl64eo61htvee9t95mp8ai9coah7av5r6v'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({
  form,
  handleSearch,
  cities,
  districts,
  towns,
  onChangeCity,
  onChangeDistrict,
  setFileList,
  setFileLogo,
  setFileList360,
  setFileListDesign,
  setFileListSample,
  fileLocation,
  fileList,
  fileLogo,
  fileList360,
  fileListDesign,
  fileListSample,
  setFileLocation,
  // overviewInfo,
  ownerInfo,
  detailInfo,
  policyInfo,
  setDataEditor,
  isText,
  setIsText
}) => {
  // Upload ảnh
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState()
  const [previewTitle, setPreviewTitle] = useState()

  const [fromPriceLabel, setFromPriceLabel] = useState('')
  const [toPriceLabel, setToPriceLabel] = useState('')

  const handleCustomRequest = async (options, type) => {
    const { file, onSuccess, onError, onProgress } = options

    // Tạo FormData và append file vào formData
    const formData = new FormData()
    type == '1' ? formData.append('file_image', file) : ''
    type == '3' ? formData.append('file_360', file) : ''
    type == '4' ? formData.append('file_image', file) : ''
    type == '5' ? formData.append('file_image', file) : ''
    type == '6' ? formData.append('file_image', file) : ''
    type == 'logo' ? formData.append('file_image', file) : ''

    try {
      // Gọi API upload thông qua hàm upLoadImage
      const response = await upLoadImage(formData)
      // Nếu có tiến trình upload, bạn có thể gọi onProgress
      if (onProgress) {
        onProgress({ percent: 100 })
      }
      // Gọi onSuccess của Upload để thông báo upload thành công
      onSuccess(response.data, file)
    } catch (error) {
      onError(error)
      openNotification('error', 'upload thất bại')
    }
  }

  const handlePreview = async (file) => {
    if (file.response) {
      setPreviewImage(file.response?.[0]?.link)
      setPreviewVisible(true)
      setPreviewTitle(false)
    } else {
      setPreviewImage(file.url)
      setPreviewVisible(true)
      setPreviewTitle(false)
    }
  }

  const handleChange = (info, type) => {
    let newFileList = [...info.fileList]

    // Chỉ cập nhật fileList nếu không có lỗi
    newFileList = newFileList.filter((file) => {
      if (file.status == 'error') {
        openNotification('error', `Upload thất bại: ${file.name}`)
      }
      return file.status !== 'error'
    })

    const updatedArray = newFileList?.map((item) => ({
      ...item,
      response: item.response
        ? item.response.map((res) => ({
            ...res,
            type: type
          }))
        : [],
      thumbUrl:
        item?.thumbUrl ||
        (item?.originFileObj && item.originFileObj instanceof File
          ? URL.createObjectURL(item.originFileObj)
          : undefined)
    }))
    type == '1' && setFileList(updatedArray)
    type == 'logo' && setFileLogo(updatedArray)
    type == '3' && setFileList360(updatedArray)
    type == '4' && setFileListDesign(updatedArray)
    type == '5' && setFileListSample(updatedArray)
    type == '6' && setFileLocation(updatedArray)
  }
  const handleCancel = () => {
    setPreviewVisible(false)
  }

  const UploadButton = () => {
    return (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )
  }

  const handleEditorChange = (key, value) => {
    setDataEditor((prev) => ({
      ...prev,
      [key]: value // Cập nhật đúng key (content, policy, detail)
    }))
  }

  const [TYPE_OF_REALSTATE, setTYPE_OF_REALSTATE] = useState([])
  const getListSelection = async () => {
    try {
      const res = await getAllSelections()
      if (res?.data) {
        const filteredData = res?.data?.list?.filter(
          (item) => item.category === 'TYPE_OF_REALSTATE_PROJECT'
        )
        const value = filteredData?.map((item) => ({
          value: item.title,
          label: item.title
        }))
        setTYPE_OF_REALSTATE(value)
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
    }
  }
  useEffect(() => {
    getListSelection()
  }, [])

  return (
    <Form
      form={form}
      onFinish={handleSearch}
      // labelCol={{ span: 7 }}
      layout="vertical"
      labelAlign="right"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      // initialValues={{ document: [{ name: '', link: '' }] }}
    >
      <div className={styles.formAdd}>
        <Form.Item label="" name="id" style={{ display: 'none' }}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Tên dự án"
          name="name"
          className={styles.formItem}
          rules={[{ required: true, message: 'Vui lòng chọn dự án' }]}
        >
          <Input placeholder={`Vui lòng nhập thông tin`} />
        </Form.Item>
        <SelectField
          label="Tỉnh/Thành phố"
          name="city_code"
          options={cities}
          onChange={onChangeCity}
          required={true}
        />
        <SelectField
          label="Quận/Huyện"
          name="district_code"
          options={districts}
          onChange={onChangeDistrict}
          required={true}
        />
        <SelectField
          label="Phường/xã"
          name="town_code"
          options={towns}
          required={true}
        />

        <InputField label="Địa chỉ" name="address" form={form} />
        <Form.Item
          label={`Giá từ: ${formatCurrencyLabel(
            form.getFieldValue('price_min')
          )}`}
          name="price_min"
          className={styles.formItem}
        >
          <InputNumber
            placeholder="Nhập giá"
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'price_min',
                  value: e.target.value?.trim()
                }
              ])
            }}
            onChange={(value) => {
              setFromPriceLabel(formatCurrencyLabel(value))
            }}
            className={styles.InputNumber}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
            parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
            maxLength={255}
          />
        </Form.Item>
        <Form.Item
          label={`Giá đến: ${formatCurrencyLabel(
            form.getFieldValue('price_max')
          )}`}
          name="price_max"
          className={styles.formItem}
        >
          <InputNumber
            placeholder="Nhập giá"
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'price_max',
                  value: e.target.value?.trim()
                }
              ])
            }}
            onChange={(value) => {
              setToPriceLabel(formatCurrencyLabel(value))
            }}
            className={styles.InputNumber}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
            parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
            maxLength={255}
          />
        </Form.Item>

        <InputField label="Chủ đầu tư" name="owner_name" form={form} />

        <Form.Item
          label="Tổng diện tích"
          name="total_acreage"
          className={styles.formItem}
        >
          <InputNumber
            placeholder="Vui lòng nhập thông tin"
            onBlur={(e) => {
              const value = parseFloat(e.target.value?.trim())

              form.setFields([
                {
                  name: 'total_acreage',
                  value: isNaN(value) ? 0 : value
                }
              ])
            }}
            style={{ width: '100%' }}
            className={'InputNumber'}
            formatter={(value) => (value ? value.replace(/[^0-9.]/g, '') : '')}
            parser={(value) => value.replace(/[^0-9.]/g, '.')}
            maxLength={255}
          />
        </Form.Item>

        <Form.Item
          label="Mật độ xây dựng"
          name="building_density"
          className={styles.formItem}
        >
          <InputNumber
            placeholder="Nhập mật độ"
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'building_density',
                  value: e.target.value?.trim()
                }
              ])
            }}
            className={styles.InputNumber}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
            parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
            maxLength={255}
          />
        </Form.Item>

        <Form.Item
          label="Loại hình nhà ở"
          name="type_of_housing"
          className={styles.formItem}
        >
          <Select
            placeholder="Chọn loại hình nhà ở"
            options={TYPE_OF_REALSTATE}
            mode="multiple"
          />
        </Form.Item>
        <InputField
          label="Đơn vị thiết kế"
          name="design_organization"
          form={form}
        />

        <InputField
          label="Đơn vị vận hành"
          name="operation_organization"
          form={form}
        />
        {/* <InputField label="Thời gian khởi công" name="start_time" form={form} /> */}
        <Form.Item
          label="Thời gian khởi công"
          name="start_time"
          className={styles.formItem}
        >
          <DatePicker
            style={{ width: '100%' }}
            placeholder="Chọn thời gian"
            format="DD/MM/YYYY"
          />
        </Form.Item>
        <Form.Item
          label="Thời gian bàn giao"
          name="handover_time"
          className={styles.formItem}
          dependencies={['start_time']}
        >
          <DatePicker
            style={{ width: '100%' }}
            placeholder="Chọn thời gian"
            format="DD/MM/YYYY"
            disabledDate={(current) => {
              const startDate = form.getFieldValue('start_time')
              return (
                startDate &&
                current &&
                current.isBefore(dayjs(startDate), 'day')
              )
            }}
          />
        </Form.Item>
        <Form.Item
          label="Mở bán"
          name="open_sale_status"
          className={styles.formItem}
        >
          <Switch />
        </Form.Item>
        {/* <InputField
          label="Thông tin chủ đầu tư"
          name="owner_description"
          form={form}
        /> */}
        <Form.Item
          label="Số điện thoại"
          name="contact_phone"
          className={styles.formItem}
          rules={[
            // {
            //   required: true,
            //   message: 'Vui lòng nhập ít nhất một số điện thoại!'
            // },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve()

                const phoneNumbers = value.split(';').map((num) => num.trim())
                const phoneRegex = /^(0[1-9][0-9]{8}|84[1-9][0-9]{8})$/

                const invalidNumbers = phoneNumbers.filter(
                  (num) => !phoneRegex.test(num)
                )

                return invalidNumbers.length === 0
                  ? Promise.resolve()
                  : Promise.reject(
                      `Số không hợp lệ: ${invalidNumbers.join(', ')}`
                    )
              }
            }
          ]}
        >
          <Input placeholder="Nhập số điện thoại, ngăn cách bằng dấu ;" />
        </Form.Item>
        <Form.Item
          label="Order"
          name="display_order"
          className={styles.formItem}
        >
          <InputNumber
            placeholder="Nhập thứ tự hiển thị"
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'display_order',
                  value: e.target.value?.trim()
                }
              ])
            }}
            className={styles.InputNumber}
            maxLength={255}
          />
        </Form.Item>
      </div>

      <div className={styles.formFull}>
        <Form.Item
          label="Link tài liệu"
          name="project_link"
          style={{ width: '100%' }}
        >
          <Input placeholder="Nhập link tài liệu" />
        </Form.Item>
      </div>

      <div className={styles.formFull}>
        {/* <SelectField
          label="Tiện ích"
          name="utility"
          mode="multiple"
          options={UTILITY_OPTIONS}
          style={{ width: '100%' }}
        /> */}
        <Form.Item
          label="Tiện ích"
          name="utility"
          mode="multiple"
          // options={UTILITY_OPTIONS}
          style={{ width: '100%' }}
        >
          <Select
            mode="multiple"
            placeholder="Chọn tiện ích"
            options={UTILITY_OPTIONS}
          />
        </Form.Item>
      </div>
      <Form.Item
        label="Logo chủ đầu tư"
        name="project_logo"
        className={styles.formFull}
      >
        <Upload
          accept="image/*"
          customRequest={(options) => handleCustomRequest(options, 'logo')}
          onChange={(e) => {
            handleChange(e, 'logo')
          }}
          listType="picture-card"
          fileList={fileLogo}
          onPreview={handlePreview}
          multiple={false}
          maxCount={1}
        >
          {fileLogo.length < 1 && <UploadButton />}
        </Upload>

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>
      <Form.Item
        label="Thông tin chủ đầu tư"
        name="owner_description"
        style={{ margin: '24px 10px 0px 10px' }}
      >
        <Editor
          apiKey={TMCE_KEY}
          initialValue={ownerInfo}
          init={{
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help'
          }}
          onEditorChange={(ct, editor) => {
            handleEditorChange('owner_description', ct)
          }}
        />
      </Form.Item>

      {/* <Form.Item
        label="Tổng quan"
        name="overview"
        style={{ margin: '24px 10px 0px 10px' }}
      >
        <Editor
          apiKey={TMCE_KEY}
          initialValue={overviewInfo}
          init={{
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help'
          }}
          onEditorChange={(ct, editor) => {
            handleEditorChange('overview', ct)
          }}
        />
      </Form.Item> */}

      <Form.Item
        label="Chính sách"
        name="policy"
        style={{ margin: '24px 10px 0px 10px' }}
      >
        <Editor
          apiKey={TMCE_KEY} // Thay bằng API key của bạn hoặc dùng phiên bản miễn phí
          initialValue={policyInfo}
          init={{
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help'
          }}
          onEditorChange={(ct, editor) => {
            handleEditorChange('policy', ct)
          }}
        />
      </Form.Item>
      <Form.Item
        label="Thông tin chi tiết dự án"
        name="detail_info"
        style={{ margin: '24px 10px 24px 10px' }}
      >
        <Editor
          apiKey={TMCE_KEY} // Thay bằng API key của bạn hoặc dùng phiên bản miễn phí
          initialValue={detailInfo}
          // init={{
          //   height: 300,
          //   menubar: false,
          //   plugins: 'link image code',
          //   toolbar:
          //     'undo redo | formatselect | bold italic | alignleft aligncenter alignright | code'
          // }}
          init={{
            height: 300,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help'
          }}
          onEditorChange={(ct, editor) => {
            handleEditorChange('detail_info', ct)
          }}
        />
      </Form.Item>

      <Form.Item
        label="Vị trí"
        name="localtion_urls"
        className={styles.formFull}
      >
        <Upload
          accept="image/*" // Chỉ cho phép upload file video
          // beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
          customRequest={(options) => handleCustomRequest(options, '6')} // Sử dụng custom request để gọi API của bạn
          onChange={(e) => {
            handleChange(e, '6')
          }}
          listType="picture-card"
          fileList={fileLocation}
          onPreview={handlePreview}
          multiple={true}
          maxCount={9}
        >
          {fileLocation.length < 9 && <UploadButton />}
        </Upload>

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>
      <Form.List name="document">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space
                key={key}
                style={{ display: 'flex', marginBottom: 8 }}
                align="baseline"
              >
                <Form.Item
                  {...restField}
                  name={[name, 'name']}
                  rules={[
                    { required: true, message: 'Vui lòng nhập tên tài liệu' }
                  ]}
                  className={styles.formItem}
                >
                  <Input placeholder="Tên tài liệu" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'link']}
                  rules={[
                    { required: true, message: 'Vui lòng nhập link' },
                    { type: 'url', message: 'Không đúng định dạng' }
                  ]}
                >
                  <Input placeholder="Link" />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item className={styles.formItem}>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Thêm tài liệu dự án
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item label="Hình ảnh" name="image_urls" className={styles.formFull}>
        <Upload
          accept="image/*" // Chỉ cho phép upload file video
          // beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
          customRequest={(options) => handleCustomRequest(options, '1')} // Sử dụng custom request để gọi API của bạn
          onChange={(e) => {
            handleChange(e, '1')
          }}
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          multiple={true}
          maxCount={9}
        >
          {fileList.length < 9 && <UploadButton />}
        </Upload>

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>

      {/* <Form.Item
        label="Ảnh 360"
        name="urls_image_360"
        className={styles.formItem}
      >
        <Upload
          customRequest={(options) => handleCustomRequest(options, '3')} 
          onChange={(e) => {
            handleChange(e, '3')
          }}
          listType="picture-card"
          fileList={fileList360}
          onPreview={handlePreview}
          multiple={true}
          maxCount={9}
        >
          {fileList360.length < 9 && <UploadButton />}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item> */}

      {isText ? (
        <Form.Item
          style={{ width: '100%' }}
          label={
            <>
              Hình ảnh 360
              <Switch
                checkedChildren="Link"
                unCheckedChildren="360"
                checked={isText}
                onChange={() => {
                  setIsText(!isText)
                  form.setFieldsValue({ urls_image_360: [''] })
                  setFileList360([])
                }}
                style={{ marginLeft: 10 }}
              />
            </>
          }
          className={styles.formFull}
        >
          <Form.List name="urls_image_360">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <div
                    key={key}
                    style={{ display: 'flex', gap: 8, width: '100%' }}
                  >
                    <Form.Item
                      {...restField}
                      name={[name, 'url']}
                      style={{ flex: 1, marginBottom: 12 }} // Đảm bảo Input chiếm toàn bộ không gian
                    >
                      <Input
                        placeholder="Nhập link..."
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() => remove(name)}
                      style={{ color: 'red' }}
                    />
                  </div>
                ))}

                {fields.length < 3 && (
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    // style={{ width: '100%' }}
                  >
                    Thêm link
                  </Button>
                )}
              </>
            )}
          </Form.List>
        </Form.Item>
      ) : (
        <Form.Item
          label={
            <>
              Hình ảnh 360
              <Switch
                checkedChildren="Link"
                unCheckedChildren="360"
                checked={isText}
                onChange={() => {
                  setIsText(!isText)
                  form.setFieldsValue({ image_360: [''] })
                  setFileList360([])
                  // form.setFieldsValue({ image_360: [] })
                }}
                style={{ marginLeft: 10 }}
              />
            </>
          }
          name="urls_image_360"
          className={styles.formFull}
        >
          <Upload
            accept="image/*" // Chỉ cho phép upload file video
            // beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
            customRequest={(options) => handleCustomRequest(options, '3')} // Sử dụng custom request để gọi API của bạn
            onChange={(e) => {
              handleChange(e, '3')
            }}
            //   listType="picture-card"
            multiple={false}
            showUploadList={{
              showPreviewIcon: false,
              showRemoveIcon: true
            }} // Hiển thị danh sách file
            fileList={fileList360}
            // onPreview={handlePreview}
            // onChange={handleChange}
          >
            <Button
              disabled={fileList360.length >= 3 ? true : false}
              icon={<UploadOutlined />}
            >
              Chọn File 360
            </Button>
          </Upload>
        </Form.Item>
      )}

      <Form.Item
        label="Video"
        name="urls_video"
        style={{ margin: '24px 10px' }}
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve()

              const urlPattern = /^(https?:\/\/)/
              if (!urlPattern.test(value)) {
                return Promise.reject(
                  new Error(
                    'Link video phải bắt đầu bằng http:// hoặc https://'
                  )
                )
              }

              return Promise.resolve()
            }
          }
        ]}
      >
        <Input
          onBlur={(e) => {
            const value = e.target.value?.trim()
            form.setFieldsValue({ urls_video: value })

            // Nếu input trống => xóa lỗi validation
            if (!value) {
              form.validateFields(['urls_video']).catch(() => {}) // Xóa lỗi nếu input rỗng
            }
          }}
        />
      </Form.Item>
      <Form.Item
        label="Ảnh mặt bằng thiết kế"
        name="urls_image_design"
        className={styles.formFull}
      >
        <Upload
          accept="image/*" // Chỉ cho phép upload file video
          // beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
          customRequest={(options) => handleCustomRequest(options, '4')} // Sử dụng custom request để gọi API của bạn
          onChange={(e) => {
            handleChange(e, '4')
          }}
          listType="picture-card"
          fileList={fileListDesign}
          onPreview={handlePreview}
          multiple={true}
          maxCount={9}
        >
          {fileListDesign.length < 9 && <UploadButton />}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>

      <Form.Item
        label="Ảnh căn hộ mẫu"
        name="urls_image_sample"
        className={styles.formFull}
      >
        <Upload
          accept="image/*" // Chỉ cho phép upload file video
          // beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
          customRequest={(options) => handleCustomRequest(options, '5')} // Sử dụng custom request để gọi API của bạn
          onChange={(e) => {
            handleChange(e, '5')
          }}
          listType="picture-card"
          fileList={fileListSample}
          onPreview={handlePreview}
          multiple={true}
          maxCount={9}
        >
          {fileListSample.length < 9 && <UploadButton />}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>
    </Form>
  )
}

export default FormPost
